/* Whomie Club – levande sök i headern (predictive search)

   SÖKORDET SKICKAS UTAN STJÄRNA, ändrat 2026-09-29.
   Tidigare lades en * till efter ordet (friterad*), för att hitta
   ord som börjar på sökordet. Det gjorde tvärtom Shopifys sökning
   mycket snålare: "friterad*" gav 2 recept, "friterad" gav 46.
   Prefixsökningen sköts i stället av options[prefix]=last, som
   är Shopifys eget sätt och som står kvar. Lägg inte tillbaka
   stjärnan. */
(function () {
  var form = document.querySelector('.WhomieHeader__Search');
  if (!form) return;
  var input = form.querySelector('input[type="search"]');
  var results = form.querySelector('.WhomieHeader__SearchResults');
  if (!input || !results) return;
  var base = form.getAttribute('data-predictive-url') || '/search/suggest';
  var searchAction = form.getAttribute('action') || '/search';
  var timer;

  function close() { results.hidden = true; }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Stänger hamburgermenyn om den står öppen när man går till
     sökrutan. Vi klickar på temats egen stängknapp i stället för
     att stänga lådan för hand, så att temats Drawer-klass får
     göra allt den ska: släppa scroll-låset, ta bort
     mörkläggningen och släppa fokusfällan. Stänger vi bara
     visuellt ligger scroll-låset kvar och sidan går inte att
     rulla. */
  function closeSidebarMenu() {
    var drawer = document.getElementById('sidebarDrawer');
    if (!drawer || drawer.getAttribute('aria-expanded') !== 'true') return;
    var closer = document.querySelector('[data-action="close-drawer"][data-toggle-id="sidebarDrawer"]');
    if (closer) closer.click();
  }

  function render(data) {
    var r = (data && data.resources && data.resources.results) || {};
    var q = r.queries || [], a = r.articles || [], p = r.products || [];
    var html = '';
    if (q.length) {
      html += '<div class="whs-group">';
      q.slice(0, 4).forEach(function (it) {
        html += '<a class="whs-item whs-query" href="' + esc(it.url) + '">' + esc(it.text) + '</a>';
      });
      html += '</div>';
    }
    if (a.length) {
      html += '<div class="whs-group"><div class="whs-head">Recept & inlägg</div>';
      a.slice(0, 10).forEach(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<span class="whs-noimg"></span>';
        html += '<a class="whs-item" href="' + esc(it.url) + '">' + img + '<span>' + esc(it.title) + '</span></a>';
      });
      html += '</div>';
    }
    if (p.length) {
      html += '<div class="whs-group"><div class="whs-head">Produkter</div>';
      p.slice(0, 4).forEach(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<span class="whs-noimg"></span>';
        html += '<a class="whs-item" href="' + esc(it.url) + '">' + img + '<span>' + esc(it.title) + '</span></a>';
      });
      html += '</div>';
    }
    var term = input.value.trim();
    var hadResults = html.length > 0;
    if (term) {
      var label = hadResults
        ? 'Visa alla tr\u00e4ffar f\u00f6r \u201C' + esc(term) + '\u201D'
        : 'S\u00f6k efter recept som inneh\u00e5ller \u201C' + esc(term) + '\u201D';
      html += '<div class="whs-group"><a class="whs-item whs-all" href="' +
        esc(searchAction) + '?q=' + encodeURIComponent(term) +
        '&type=article,product&options[prefix]=last">' + label + '</a></div>';
    }
    results.innerHTML = html;
    results.hidden = false;
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { close(); return; }
    timer = setTimeout(function () {
      var url = base + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=query,article,product&resources[limit]=10' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(render)
        .catch(function () { close(); });
    }, 200);
  });

  input.addEventListener('focus', function () {
    closeSidebarMenu();
    if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false;
  });
  form.addEventListener('mousedown', closeSidebarMenu);
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); input.blur(); }
  });

  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (q) {
      e.preventDefault();
      window.location.href = searchAction + '?q=' + encodeURIComponent(q) +
        '&type=article,product&options[prefix]=last';
    }
  });
})();
